import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment';

// components
import { CButton, CImage, CDateRangePicker } from '@coreui/react-pro'
import Select from 'react-select';
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'
import { 
  singleInvoiceStatusOptionSelect,
  singleInvoiceStatusPaymentOptionSelect,
  singleClientsOptionsSelect
} from '../../helpers/format-options'
import { customStyles } from '../../components/custom-styles/selectStyles'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnInvoiceList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

const InvoiceList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [invoiceList, setInvoiceList] = useState([]);
  const [invoiceListCount, seInvoiceListCount] = useState(0);
  const [invoiceListPerPage, setInvoiceListPerPage] = useState(10);
  const [activeInvoiceListPage, setActiveInvoiceListPage] = useState(1);
  const [searchInvoiceListFilter, setSearchInvoiceListFilter] = useState("");
  const [columnInvoiceListSorter, setColumnInvoiceListSorter] = useState({ column: "updatedAt", state: "desc" });

  const [clientOptions, setClientOptions] = useState([])
  
  const [filterStartDate, setFilterStartDate] = useState(null)
  const [filterEndDate, setFilterEndDate] = useState(null)

  const [columnFilter, setColumnFilter] = useState({})
  const [updateColumnList, setUpdateColumnList] = useState(columnInvoiceList)

  useEffect(() => {
    let queries = {
      search: searchInvoiceListFilter,
      limit: invoiceListPerPage,
      offset: invoiceListPerPage * activeInvoiceListPage - invoiceListPerPage,
      sort:
        (columnInvoiceListSorter &&
          `${columnInvoiceListSorter.column}%${columnInvoiceListSorter.state}`) ||
        "",
    };
    if (columnFilter) {
      Object.keys(columnFilter).forEach((key) => {
        if (columnFilter[key]) {
          queries[key] = columnFilter[key].value
        } else {
          queries[key] = ''
        }
      })
    }
    queries = formUrlQuery(queries);
    fetchAllInvoices(queries);
  }, [
    searchInvoiceListFilter,
    invoiceListPerPage,
    activeInvoiceListPage,
    columnInvoiceListSorter,
    columnFilter
  ]);

  useEffect(() => {
    fetchAllClient()
  }, [])

  useEffect(() => {
    let columnList = updateColumnList?.map((list) => {
      let data = list

      if (data.key == 'client_name' && clientOptions?.length > 0) {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={clientOptions}
              value={columnFilter.client_id}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue);
                setColumnFilter((prevState) => ({
                  ...prevState,
                  client_id: selectedValue
                }));
                setActiveInvoiceListPage(1)
              }}
              isClearable
              styles={customStyles}
            />
          )
        }
      }

      if (data.key == 'status_invoice') {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={singleInvoiceStatusOptionSelect()}
              value={columnFilter.is_draft}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue);
                setColumnFilter((prevState) => ({
                  ...prevState,
                  is_draft: selectedValue
                }));
                setActiveInvoiceListPage(1)
              }}
              isClearable
              styles={customStyles}
            />
          )
        }
      }

      if (data.key == 'invoice_payment') {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={singleInvoiceStatusPaymentOptionSelect()}
              value={columnFilter.is_paid}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue);
                setColumnFilter((prevState) => ({
                  ...prevState,
                  is_paid: selectedValue
                }));
                setActiveInvoiceListPage(1)
              }}
              isClearable
              styles={customStyles}
            />
          )
        }
      }

      if (data.key == 'createdAt') {
        data.filter = () => {
          return (
            <CDateRangePicker
              footer
              cleaner
              size="sm"
              startDate={filterStartDate}
              endDate={filterEndDate}
              onStartDateChange={(date) => {
                if (date) {
                  const itemDate = moment(date).format('YYYY-MM-DD')
                  setFilterStartDate(itemDate)

                  setColumnFilter((prevState) => ({
                    ...prevState,
                    created_start_date: {
                      value: itemDate,
                    }
                  }));

                  if (filterEndDate) {
                    setActiveInvoiceListPage(1)
                  }
                } else {
                  setColumnFilter((prevState) => ({
                    ...prevState,
                    created_start_date: null
                  }));
                  setFilterStartDate(null)
                }
              }}
              onEndDateChange={(date) => {
                if (date) {
                  const itemDate = moment(date).format('YYYY-MM-DD')
                  setFilterEndDate(itemDate)

                  setColumnFilter((prevState) => ({
                    ...prevState,
                    created_end_date: {
                      value: itemDate,
                    }
                  }));

                  if (filterStartDate) {
                    setActiveInvoiceListPage(1)
                  }
                } else {
                  setColumnFilter((prevState) => ({
                    ...prevState,
                    created_end_date: null
                  }));
                  setFilterEndDate(null)
                }
              }}
            />
          )
        }
      }

      return data
    })

    setUpdateColumnList(columnList)
  }, [columnFilter, clientOptions])

  const handleSearchItems = (search) => {
    setActiveInvoiceListPage(1)
    setSearchInvoiceListFilter(search);
  }

  const fetchAllInvoices = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/invoice?${queries}`
    })
      .then(({ data }) => {
        let tempInvoiceList = data?.value
        tempInvoiceList = tempInvoiceList?.map((invoice) => ({
          ...invoice,
          client_name: invoice?.client?.name || '-',
          status_invoice: invoice?.is_draft ? 'Draft' : 'Published',
          invoice_payment: invoice?.is_paid ? 'Paid' : 'Not Paid',
        }))
        setInvoiceList(tempInvoiceList);
        if (activeInvoiceListPage === 1) {
          seInvoiceListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const fetchAllClient = () => {
    let url = `/api/tracker/v1/client`
    Axios({
      method: "get",
      url,
    })
      .then(({ data }) => {
        if (data?.success) {
          setClientOptions(singleClientsOptionsSelect(data.value))
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/tracker/v1/invoice/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllInvoices()
          showSuccess('Invoice has been successfully deleted')
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/invoice/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={showConfirmDelete?.item?.name}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/invoice/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Invoice
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Invoice List</h4>}
        bodyContent={
          <AppTable
            invoiceListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnInvoiceList}
            tableContent={invoiceList}
            contentPerPage={invoiceListPerPage}
            activeContentPage={activeInvoiceListPage}
            contentCount={invoiceListCount}
            searchContentFilter={searchInvoiceListFilter}
            setActiveContentPage={setActiveInvoiceListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setInvoiceListPerPage}
            setColumnContentSorter={setColumnInvoiceListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
            isShowColumnFilter={true}
          />
        }
      />
    </>
  )
}

export default InvoiceList